import FileUpload from './FileUpload';

export * from './FileUploadProps';
export default FileUpload;
